/**
 * i18n. Finlandes por defecto: el destinatario es una pyme de Levi, no un
 * público hispanohablante. El detector de idioma del navegador NO se usa a
 * proposito: no adivina bien el finlandés, y abrir la app en inglés por
 * error del sistema seria peor que mostrar el idioma de siempre.
 */

import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import en from './locales/en.json'
import es from './locales/es.json'
import fi from './locales/fi.json'

export const SUPPORTED = ['fi', 'en', 'es'] as const
export const DEFAULT_LOCALE = 'en'

/**
 * Resuelve el idioma inicial:
 * 1. Preferencia guardada en localStorage si el usuario ya la seleccionó.
 * 2. Idioma del navegador (navigator.language):
 *    - Español (es-*) -> 'es'
 *    - Finlandés (fi-*) -> 'fi'
 *    - Cualquier otro (en-*, de-*, fr-*, sv-*, etc.) -> 'en' (Inglés internacional)
 */
export function initialLocale(): 'fi' | 'en' | 'es' {
  const saved = typeof window !== 'undefined' ? localStorage.getItem('lma.locale') : null
  if (saved && SUPPORTED.includes(saved as (typeof SUPPORTED)[number])) {
    return saved as (typeof SUPPORTED)[number]
  }

  if (typeof navigator !== 'undefined') {
    const navLangs = navigator.languages || [navigator.language || '']
    for (const lang of navLangs) {
      const lower = (lang || '').toLowerCase()
      if (lower.startsWith('fi')) return 'fi'
      if (lower.startsWith('es')) return 'es'
    }
  }

  // Resto de países / idiomas internacionales
  return 'en'
}

void i18n.use(initReactI18next).init({
  resources: {
    fi: { translation: fi },
    en: { translation: en },
    es: { translation: es },
  },
  lng: initialLocale(),
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
})

export function setLocale(locale: string): void {
  if (!SUPPORTED.includes(locale as (typeof SUPPORTED)[number])) return
  localStorage.setItem('lma.locale', locale)
  void i18n.changeLanguage(locale)
  document.documentElement.lang = locale
}

export default i18n
